import { AlphaOBoxIcon } from './AlphaOBoxIcon';

/**
 * author: GreenTurtwig
 * id 53B24801-62B0-46AC-9474-90DCA470E506
 * name alpha-o-box
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-o-box.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetOBoxIcon = AlphaOBoxIcon;
export default AlphabetOBoxIcon